'use client';

// Smooth scroll is disabled — native scrolling is hardware-accelerated and
// always 60fps. Lenis with duration > 0.8 makes scrolling feel sluggish.
// CSS scroll-behavior: smooth handles anchor links natively.

interface Props {
  children: React.ReactNode;
}

export function SmoothScrollProvider({ children }: Props) {
  return <>{children}</>;
}
